module.exports = __webpack_public_path__ + "img/Monte_Kope_89.0f1358a7.jpg";